import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import 'regenerator-runtime/runtime';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import { html, svg, LitElement, directive, until, NodePart, TemplateResult, defaultTemplateProcessor, render } from '@onviobr/lit-prebuilt';
export * from '@onviobr/lit-prebuilt';
import { registerLibrary } from '@onviobr/app-info';
import 'core-js/modules/es.function.name';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _get from '@babel/runtime-corejs3/helpers/get';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _createSuper from '@babel/runtime-corejs3/helpers/createSuper';
import 'core-js/modules/es.array.join';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import { getCurrentLanguage, translate, translateHTML, onLanguageChange } from '@onviobr/services/i18n';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _everyInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/every';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _WeakMap from '@babel/runtime-corejs3/core-js-stable/weak-map';

var BlueElement = /*#__PURE__*/function (_LitElement) {
  _inherits(BlueElement, _LitElement);

  var _super = _createSuper(BlueElement);

  _createClass(BlueElement, null, [{
    key: "is",
    get: function get() {
      throw new Error("The 'is' static property is not defined in the ".concat(this.name, " class"));
    }
  }]);

  function BlueElement() {
    var _this;

    _classCallCheck(this, BlueElement);

    _this = _super.call(this);
    _this.html = html;
    _this.svg = svg;
    return _this;
  }

  _createClass(BlueElement, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this.attachShadow === undefined ? this : _get(_getPrototypeOf(BlueElement.prototype), "createRenderRoot", this).call(this);
    }
  }]);

  return BlueElement;
}(LitElement);

var previousValues = new _WeakMap();
var internalGuard = directive(function (value, f) {
  return function (part) {
    var previousValue = previousValues.get(part);

    if (_Array$isArray(value)) {
      if (_Array$isArray(previousValue) && previousValue.length === value.length && _everyInstanceProperty(value).call(value, function (v, i) {
        return v === previousValue[i];
      })) {
        return;
      }
    } else if (previousValue === value && (value !== undefined || previousValues.has(part))) {
      return;
    }

    part.setValue(f(part));
    previousValues.set(part, _Array$isArray(value) ? _toConsumableArray(value) : value);
  };
});

function createUniqueStringKey(key) {
  var _context, _context3, _context4;

  var interpolation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var interStr = _mapInstanceProperty(_context = _Object$entries(interpolation)).call(_context, function (_ref) {
    var _context2;

    var _ref2 = _slicedToArray(_ref, 2),
        a = _ref2[0],
        b = _ref2[1];

    return _concatInstanceProperty(_context2 = "".concat(a)).call(_context2, b);
  }).join('');

  return _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "".concat(key)).call(_context4, interStr)).call(_context3, getCurrentLanguage());
}

function genericDirective(key, fn, interpolation) {
  return internalGuard(createUniqueStringKey(key, interpolation), function (part) {
    var safeTranslate = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(part instanceof NodePart)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", fn(key, interpolation));

              case 2:
                return _context5.abrupt("return", fn(key, interpolation).then(function (value) {
                  if (typeof value !== 'string' && !(part instanceof NodePart)) {
                    throw new TypeError('Multipart translations (HTML) can not be used on attributes or properties');
                  }

                  return value;
                }));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee);
      }));

      return function safeTranslate() {
        return _ref3.apply(this, arguments);
      };
    }();

    return until(safeTranslate().catch(console.error));
  });
}

function translateDirective(key, interpolation) {
  return genericDirective(key, translate, interpolation);
}
function translateHTMLDirective(key, interpolation) {
  return genericDirective(key, translateHTML, interpolation);
}
function i18nMixin(Base) {
  var _temp;

  return _temp = /*#__PURE__*/function (_Base) {
    _inherits(_temp, _Base);

    var _super = _createSuper(_temp);

    function _temp() {
      var _context6;

      var _this;

      _classCallCheck(this, _temp);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, _concatInstanceProperty(_context6 = [this]).call(_context6, args));
      _this.i18n = void 0;
      _this.i18nHTML = void 0;
      _this._i18nUnregister = void 0;
      _this.i18n = translateDirective;
      _this.i18nHTML = translateHTMLDirective;
      return _this;
    }

    _createClass(_temp, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _context7;

        _get(_getPrototypeOf(_temp.prototype), "connectedCallback", this).call(this);

        this.releaseLanguage();
        this._i18nUnregister = onLanguageChange(_bindInstanceProperty(_context7 = this.requestUpdate).call(_context7, this));
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(_temp.prototype), "disconnectedCallback", this).call(this);

        this.releaseLanguage();
      }
    }, {
      key: "releaseLanguage",
      value: function releaseLanguage() {
        if (this._i18nUnregister) {
          this._i18nUnregister();

          this._i18nUnregister = undefined;
        }
      }
    }]);

    return _temp;
  }(Base), _temp;
}

var version = "8.5.1";
var name = "@onviobr/element";
var register = function register(component) {
  if (customElements.get(component.is)) {
    if (customElements.get(component.is) !== component) {
      console.warn("Custom element ".concat(component.is, " is already registered and the constructors are not the same"), component, customElements.get(component.is));
    }

    return;
  }

  return customElements.define(component.is, component);
};
function renderElement(_x) {
  return _renderElement.apply(this, arguments);
}

function _renderElement() {
  _renderElement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(template) {
    var strings, templateResult, container, element;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            strings = [template];
            strings.raw = [template];
            templateResult = new TemplateResult(strings, [], 'html', defaultTemplateProcessor);
            container = document.createDocumentFragment();
            render(templateResult, container);
            _context.next = 7;
            return new _Promise(function (resolve) {
              return requestAnimationFrame(function () {
                return resolve();
              });
            });

          case 7:
            element = container.querySelector(':first-child');

            if (!(element === null)) {
              _context.next = 10;
              break;
            }

            throw new Error('The template did not generate an DOM element');

          case 10:
            return _context.abrupt("return", element);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _renderElement.apply(this, arguments);
}

registerLibrary({
  version: version,
  name: name
});

export { BlueElement, i18nMixin, register, renderElement, translateDirective, translateHTMLDirective };
